import { Modality } from '@models/Modality';

// eslint-disable-next-line max-len
export const getFrequencyViewValue = (frequency: Modality | null | undefined = Modality.Monthly): string => frequency === Modality.Monthly ? 'month' : 'year';
